import { render, staticRenderFns } from "./DecastRecordDetails.vue?vue&type=template&id=ea7f5704&"
import script from "./DecastRecordDetails.vue?vue&type=script&lang=js&"
export * from "./DecastRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./DecastRecordDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports